module.exports = __webpack_public_path__ + "dist/media/logo--it.8c90acb2.svg";